import { inject, Injectable } from '@angular/core';
import { CalAngularService } from '@cvx/cal-angular';
import { HttpHeaders } from '@angular/common/http';
import { LoggedInUserService } from './logged-in-user-service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private authService: CalAngularService = inject(CalAngularService);
  private loggedInUserService: LoggedInUserService = inject(LoggedInUserService);

  login() {
    if (this.authService.isUserSignedIn()) {
      this.loggedInUserService.setCurrentUser(this.authService.cvxClaimsPrincipal);
    } else {
      this.authService.userInitiatedSignIn();
    }
  }

  private getToken(scopes: string[]) {

    this.authService.getAADToken(scopes, false).subscribe({
      next: (response) => {

        //https://jwt.io/
        const token = response ? response.toString() : '';
        
        console.log('token:', token);

        // this.userProfileStore.SetToken(token);

        // this.userProfileStore.Authenticate(true);

        // this.userProfileStore.EndLoading();

        //----------------------------------------------------------------------------------
        let headers = new HttpHeaders({
            'Authorization': 'Bearer ' + token
        });

        //IA: Fix this to get the user image
        // this.apiService.get_all(`https://graph.microsoft.com/v1.0/users/${this.userProfileStore.profile()?.id?.() ?? ''}/photo/$value`,
        //     {
        //         headers: headers,
        //         responseType: 'blob'
        //     }
        // ).subscribe(data => {
        //     let objectURL = URL.createObjectURL(data);
        //     // this.userProfileStore.SetUserImage(objectURL);
        // });
        //----------------------------------------------------------------------------------


        // // const headers = new HttpHeaders().set('Authorization', 'Bearer ' + this.token);
        // // headers.set('Access-Control-Allow-Origin', '*');
        // // headers.set('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept');
        // // headers.set('Content-Type', 'image/jpeg');
        // // const options = {
        // //     method: "GET",
        // //     mode: "cors",
        // //     //responseType: 'blob', 
        // //     headers: headers,
        // // };

        // // this.httpClient.get(`https://graph.microsoft.com/v1.0/users/${this.currentUserProfile.objectId}/photo/$value`, options).subscribe((data) => {

        // //     debugger;

        // //     console.log(data);
        // //     //     this.homeService.userProfile = data;
        // //     //     console.log("data:", data);
        // //     //     this.event.newEvent({ name: 'profile', userProfile: data });
        // //     //     this.profileLoaded = true;
        // // });
        // //----------------------------------------------------------------------------------

      },
      error: (err) => {
        // this.userProfileStore.EndLoadingWithError(err);

        console.log('Unable to create audience token');
        console.log(err);
      },
    });
  }

}


// -----login
// logout
// getToken
// isAuthenticated
// refreshToken
// register (si también manejas el registro de usuarios)
// handleError